<template>
  <div class="cb-troubleshoot-page">
    <div class="cb-troubleshoot-page__container">
      <h1 class="cb-heading-4" tabindex="-1" ref="title">
        Troubleshoot your CellBridge device
      </h1>
      <div class="cb-troubleshoot-page__container__content">
        <cb-troubleshoot :title="false"></cb-troubleshoot>
      </div>
    </div>
  </div>
</template>

<script>
import Troubleshoot from '../components/Troubleshoot.vue';

export default {
  mounted() {
    this.$refs.title.focus();
  },
  components: {
    cbTroubleshoot: Troubleshoot,
  },
};
</script>

<style lang="scss" scoped>
.cb-troubleshoot-page {
  background-color: $azure;
  min-height: 100vh;
  width: 100vw;
  padding: 48px 20px 20px;
  box-sizing: border-box;

  &__container {
    width: 100%;

    .cb-heading-4 {
      color: white;
      padding: 0 20px;
      max-width: 657px;
      margin: 0 auto 48px;
    }

    &__content {
      max-width: 657px;
      margin: 0 auto;
      background-color: white;
      box-sizing: border-box;
      padding: 40px 20px 28px;
      border-radius: 10px;
    }
  }

  @include desktop {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: unset;
    padding: 20px;
    box-sizing: border-box;

    &__container {
      background-color: $azure;
      box-sizing: border-box;
      padding: 48px 228px;
      width: 1113px;

      .cb-heading-4 {
        text-align: center;
      }
    }
  }
}
</style>
